<div class="heading-elements">
  <button class="btn btn-sm round btn-outline-info" data-toggle="modal" data-target="#modalRegisterForm">
    Add IMTO <i class="fa fa-plus"></i></button>
    <div class="modal fade" id="modalRegisterForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
      aria-hidden="true">
      @if (getSide() !== true) {
        <form [formGroup]="form" (ngSubmit)="addAgent()">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header text-center">
                <h4 class="modal-title w-100 font-weight-bold">Add IMTO</h4>
                <button type="button" class="close" data-dismiss="modal" id="closeModal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <!--<div *ngIf="form.errors" class="alert alert-danger error">-->
                <!--Username or email is invalid-->
              <!--</div>-->
            </div>
            <div class="modal-body mx-3">
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="companyName" class="col-sm-4 col-form-label" >IMTO name</label>
                  <div class="col-sm-8">
                    <input type="text" formControlName="name" class="form-control round" id="companyName">
                  </div>
                  @if (name.touched && name.invalid) {
                    <div class="alert alert-danger error">
                      @if (name.errors.required) {
                        <div>IMTO's Name is required</div>
                      }
                      @if (name.errors.minlength) {
                        <div>IMTO's Name should be minimum of 3 characters</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="email" class="col-sm-4 col-form-label" >Email</label>
                  <div class="col-sm-8">
                    <input type="email" formControlName="email" class="form-control round" id="email" appUniqueEmailValidator>
                  </div>
                  @if (email.pending) {
                    <div class="alert alert-default error">Checking for Email Uniqueness...</div>
                  }
                  @if (email.invalid && (email.touched || email.dirty)) {
                    <div class="alert alert-danger error">
                      @if (email.errors.required) {
                        <div>Email is required</div>
                      }
                      @if (email.errors.cannotContainSpace) {
                        <div>Email cannot contain space</div>
                      }
                      @if (email.errors.uniqueEmail) {
                        <div>Email already exists</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="phone" class="col-sm-4 col-form-label" >Telephone</label>
                  <div class="col-sm-8">
                    <input type="tel" formControlName="phone_number" name="phone_number" class="form-control round" id="phone" >
                  </div>
                  @if (phone_number.invalid && (phone_number.touched || phone_number.dirty)) {
                    <div class="alert alert-danger error">
                      @if (phone_number.errors.required) {
                        <div>Email is required</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <!--<div formGroupName="secret">-->
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="password" class="col-sm-4 col-form-label" >Password</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <input [type]="passwordType" formControlName="password"  name="password" class="form-control round" id="password"/>
                      <div class="input-group-append">
                        <span class="input-group-text round" (click)="togglePassword()">
                          <i class="fa fa-eye-slash" [(class)]="icon"></i>
                        </span>
                      </div>
                    </div>
                    <a (click)="onClickGenerate()" style="color:#1E9FF2;">Auto-generate random password</a>
                  </div>
                  @if (password.touched && password.invalid) {
                    <div class="alert alert-danger error">
                      @if (password.errors.required) {
                        <div>Password is required</div>
                      }
                      @if (password.errors.minlength) {
                        <div>Password should be minimum of 6 characters</div>
                      }
                      @if (password.errors.cannotContainSpace) {
                        <div>Password cannot contain space</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="cpassword" class="col-sm-4 col-form-label" >Confirm Password</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <input [type]="passwordType" formControlName="cpassword" class="form-control round" id="cpassword"/>
                      <div class="input-group-append">
                        <span class="input-group-text round" (click)="togglePassword()">
                          <i class="fa fa-eye-slash" [(class)]="icon"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  @if (cpassword.touched && cpassword.invalid) {
                    <div class="alert alert-danger error">
                      @if (cpassword.errors.required) {
                        <div>Confirm Password is required</div>
                      }
                      @if (cpassword.errors.minlength) {
                        <div>Password should be minimum of 6 characters</div>
                      }
                      @if (cpassword.errors.cannotContainSpace) {
                        <div>Password cannot contain space</div>
                      }
                    </div>
                  }
                  @if (password.valid && form.invalid && form.hasError('passwordsShouldMatch')) {
                    <div class="alert alert-danger error">
                      Passwords do not match.
                    </div>
                  }
                </div>
              </div>
            <!--</div>-->
            <div class="md-form mb-1">
              <div class="form-group row">
                <label for="address" class="col-sm-4 col-form-label" >Address</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control round" id="address" formControlName="address"  name="address" >
                </div>
                @if (address.touched && address.invalid) {
                  <div class="alert alert-danger error">
                    @if (address.errors.required) {
                      <div>Address is required</div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="md-form mb-1">
              <div class="form-group row">
                <label for="statee" class="col-sm-4 col-form-label" >Location</label>
                <div class="col-sm-4 pl-5">
                  <!--<input type="text" formControlName="country_id" name="country" class="form-control round " id="countryy" placeholder="Country">-->
                  <input id="countryy" formControlName="country_id"  type="text"  class="form-control round" name="country_id" [class.is-invalid]="searchFailed"  [ngbTypeahead]="search" placeholder="Search Country" />
                  @if (searching) {
                    <span>searching...</span>
                  }
                  @if (searchFailed) {
                    <div class="invalid-feedback">Sorry, suggestions could not be loaded.</div>
                  }
                </div>
                <div class="col-sm-4 pr-5">
                  <!--<input type="text" formControlName="state_id" class="form-control round " id="statee" placeholder="State/Province">-->
                  <input type="text" formControlName="state_id" class="form-control round" id="statee" name="state"  [class.is-invalid]="searchFailed" [ngbTypeahead]="searchState" placeholder="Search State" />
                  @if (searching) {
                    <span>searching...</span>
                  }
                  @if (searchFailed) {
                    <div class="invalid-feedback">Sorry, suggestions could not be loaded.</div>
                  }
                </div>
                @if (country.touched && country.invalid) {
                  <div class="alert alert-danger error">
                    @if (country.errors.required) {
                      <div>Country is required</div>
                    }
                  </div>
                }
                @if (state.touched && state.invalid) {
                  <div class="alert alert-danger error">
                    @if (state.errors.required) {
                      <div>State is required</div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-success btn-round pl-30 pr-30" [disabled]="form.invalid || clicked === true">Create </button>@if (clicked === true) {
            <i class="icons icon-loading"></i>
          }
        </div>
      </div>
    </div>
  </form>
}
@if (getSide() === true) {
  <form [formGroup]="formLive" (ngSubmit)="addAgentToLive()">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <h4 class="modal-title w-100 font-weight-bold">Add IMTO Test to Live</h4>
          <button type="button" class="close" data-dismiss="modal" id="closeModal1" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <!--<div *ngIf="form.errors" class="alert alert-danger error">-->
          <!--Username or email is invalid-->
        <!--</div>-->
      </div>
      <div class="modal-body mx-3">
        <div class="md-form mb-1">
          <div class="form-group row">
            <label for="companyName" class="col-sm-4 col-form-label" >IMTO name</label>
            <div class="col-sm-8">
              <select class="form-control round" formControlName="name" name="name" id="agent_name">
                @for (agent of agents; track agent) {
                  <option [value]="agent.slug">{{ agent.name }}</option>
                }
              </select>
            </div>
            @if (nameLive.touched && nameLive.invalid) {
              <div class="alert alert-danger error">
                @if (nameLive.errors.required) {
                  <div>IMTO's Name is required</div>
                }
                @if (nameLive.errors.minlength) {
                  <div>IMTO's Name should be minimum of 3 characters</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="md-form mb-1">
          <div class="form-group row">
            <label for="passwordd" class="col-sm-4 col-form-label" >Password</label>
            <div class="col-sm-8">
              <div class="input-group">
                <input [type]="passwordType" formControlName="password"  name="password" class="form-control round" id="passwordd"/>
                <div class="input-group-append">
                  <span class="input-group-text round" (click)="togglePassword()">
                    <i class="fa fa-eye-slash" [(class)]="icon"></i>
                  </span>
                </div>
              </div>
              <a (click)="onClickGenerateLive()" style="color:#1E9FF2;">Auto-generate random password</a>
            </div>
            @if (passwordLive.touched && passwordLive.invalid) {
              <div class="alert alert-danger error">
                @if (passwordLive.errors.required) {
                  <div>Password is required</div>
                }
                @if (passwordLive.errors.minlength) {
                  <div>Password should be minimum of 6 characters</div>
                }
                @if (passwordLive.errors.cannotContainSpace) {
                  <div>Password cannot contain space</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="md-form mb-1">
          <div class="form-group row">
            <label for="cpasswordd" class="col-sm-4 col-form-label" >Confirm Password</label>
            <div class="col-sm-8">
              <div class="input-group">
                <input [type]="passwordType" formControlName="cpassword" class="form-control round" id="cpasswordd"/>
                <div class="input-group-append">
                  <span class="input-group-text round" (click)="togglePassword()">
                    <i class="fa fa-eye-slash" [(class)]="icon"></i>
                  </span>
                </div>
              </div>
            </div>
            @if (cpasswordLive.touched && cpasswordLive.invalid) {
              <div class="alert alert-danger error">
                @if (cpasswordLive.errors.required) {
                  <div>Confirm Password is required</div>
                }
                @if (cpasswordLive.errors.minlength) {
                  <div>Password should be minimum of 6 characters</div>
                }
                @if (cpasswordLive.errors.cannotContainSpace) {
                  <div>Password cannot contain space</div>
                }
              </div>
            }
            @if (passwordLive.valid && formLive.invalid && formLive.hasError('passwordsShouldMatch')) {
              <div class="alert alert-danger error">
                Passwords do not match.
              </div>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-success btn-round pl-30 pr-30" [disabled]="formLive.invalid || clicked === true">Create Live</button>@if (clicked === true) {
        <i class="icons icon-loading"></i>
      }
    </div>
  </div>
</div>
</form>
}
</div>

</div>
